import request from '@/utils/request'

// 用料填报-溯源项信息
// 用料填报列表
export const getMaterialuseinfoList = ({ page, size, itemsId }) => {
  return request({
    url: `/trace/materialuseinfo/${itemsId}/${page}/${size}`
  })
}
// 溯源项信息
export const getMaterialuseinfoItemsList = (productId) => {
  return request({
    url: `/trace/materialuseinfo/itmes/${productId}`
  })
}

export const postMaterialuseinfoEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/materialuseinfo',
    data
  })
}

export const putMaterialuseinfoAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/materialuseinfo',
    data
  })
}

export const getMaterialuseinfoDetail = (id) => {
  return request({
    url: `/trace/materialuseinfo/${id}`
  })
}

export const deleteMaterialuseinfoDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/materialuseinfo/${id}`
  })
}

export const delMaterialuseinfoList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/materialuseinfo/all',
    data
  })
}
